import {
    GET_GATICKET_LOADING, GATICKET_DATA_SUCCESS, GATICKET_DATA_ERROR,
    GATICKETDISPLAYAREA_DATA_SUCCESS
} from "../actions/actionGATicket";
import { apiDisplayAreas } from 'api';
import { apiGATicket } from 'api';
import { put, takeEvery } from 'redux-saga/effects';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {
        throw await response.json();
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get GATickets, response status: " + response.status + "\"}]}")
    }
}

function* fetchGaTicketsData(action) {
    try {
        const displayAreasdata = yield fetchAsync(apiDisplayAreas, "products")
        let params = "DisplayArea=" + action.payload.DisplayArea;
        if (action.payload.GACouponCode)
            params += "&GACouponCode=" + action.payload.GACouponCode;
        const gaTickets = yield fetchAsync(apiGATicket, params)
        if (gaTickets == "nocontent") throw "{\"Errors\":[{\"ErrorMessage\":\"Unable to get GATickets\"}]}"
        else {
            yield put({ type: GATICKETDISPLAYAREA_DATA_SUCCESS, payload: displayAreasdata });
            yield put({ type: GATICKET_DATA_SUCCESS, payload: gaTickets });
        }
    } catch (e) {
        yield put({ type: GATICKET_DATA_ERROR, error: e });
    }
}

export const sagaGaTicket = [
    takeEvery(GET_GATICKET_LOADING, fetchGaTicketsData)
];
